export const UPDATE_PROMOTIONS = "@iweb/UPDATE_PROMOTIONS"
export const SET_PROMOTIONS = "@iweb/SET_PROMOTIONS"
